import React, { useMemo, useCallback } from 'react';
import { useApp } from '@dex/bubl-dash/src/lib/functions/useApp';
import { useForm } from '@dex/bubl-dash/src/lib/functions/useForm';
import { Row, Col } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import DeletePanel from '@dex/bubl-dash/src/lib/components/SinglePanels/DeletePanel';
import WatchVideosApi from '../WatchVideosApi';
import WatchVideosCreateEditForm from './WatchVideosCreateEditForm';
import { Space } from '@dex/bubl-dash';
import WatchVideosAdsForm from './WatchVideosAdsForm';

const WatchVideosSingleEdit: React.FC<any> = (props: any) => {

    const app = useApp();

    const { data } = props;

    const form = useForm(data);

    const update = WatchVideosApi.update(data.id, "update", {
        onComplete: (data) => {

            app.alert('Video Saved', 'success');

        }
    });

    const handleSubmit = useCallback((values) => {

        update.run({ data: values });

    }, [props]);

    return useMemo(() => (

        <Row
            gutter={'auto'}
        >

            <Col
                className={'main'}
            >

                <WatchVideosCreateEditForm
                    mode={"edit"}
                    form={form}
                    data={data}
                    handleSubmit={handleSubmit}
                    process={update}
                />

                {app.userCan(["updateAdsWatchVideos"]) &&
                    <>

                        <Space />

                        <WatchVideosAdsForm
                            data={data}
                        />

                    </>

                }

            </Col>

            <Col
                className={'side'}
            >

                <DeletePanel
                    data={data}
                />

            </Col>

        </Row>

    ), [data, form, update]);

}

export default WatchVideosSingleEdit;
